import { NgModule, isDevMode, inject, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, HttpBackend } from '@angular/common/http';

/* App Root */
import { AppComponent } from './app.component';

/* translation */
import { TranslateModule, TranslateLoader, provideTranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

/* auth */
import { RouteModule } from './route/route.module';
import { ShouldLoginComponent } from './should-login.component';

/* routing */
import { LivedokwebRouting } from './livedokweb.routes';

/* Feature Modules */
import { BookmarksModule } from './bookmarks/bookmarks.module';
import { DocumentsModule } from './documents/documents.module';
import { PdfViewModule } from './pdf/pdf-view.module';
import { SearchModule } from './search/search.module';
import { SharedModule } from './shared/shared.module';
import { ShellModule } from './shell/shell.module';
import { WebDokuModule } from './web-doku/web-doku.module';
import { MessagesModule } from './messages/messages.module';
import { PermaModule } from './perma/perma.module';
import { InfoModule } from './info/info.module';

/* support for initial server side configuration */
import { AppConfig } from './appconfig';
import { TokenInterceptor } from './route/token.interceptor';
import { RoesbergModule } from '@ldw/roesberg';
import { HttpLoadingIterceptorService } from './shell/http-loading-iterceptor.service';
import { ServiceWorkerModule } from '@angular/service-worker';
import { TitleStrategy } from '@angular/router';
import { TranslatedTitleStrategy } from './route/translated-title.startegy';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [AppComponent, ShouldLoginComponent],
  bootstrap: [AppComponent],
  imports: [BrowserModule,
    RouteModule.forRoot(),
    LivedokwebRouting,
    RoesbergModule,
    BookmarksModule,
    DocumentsModule,
    PdfViewModule,
    InfoModule,
    SearchModule,
    PermaModule,
    SharedModule,
    ShellModule,
    WebDokuModule,
    MessagesModule,
    BrowserAnimationsModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    })], providers: [
      provideTranslateService({
        fallbackLang: 'en',
        loader: {
          provide: TranslateLoader,
          useFactory: (backend: HttpBackend) => new TranslateHttpLoader(new HttpClient(backend), '/assets/i18n/', '.json'),
          deps: [HttpBackend]
        }
      }
      ),
      provideAppInitializer(() => {
        const initializerFn = ((config: AppConfig) => () => config.loadConfig())(inject(AppConfig));
        return initializerFn();
      }),
      { provide: HTTP_INTERCEPTORS, useClass: HttpLoadingIterceptorService, multi: true },
      { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
      provideHttpClient(withInterceptorsFromDi()),
      { provide: TitleStrategy, useClass: TranslatedTitleStrategy }
    ]
})
export class AppModule { }
